interface V3IconPlayProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
}

export const V3IconPlay = ({ color = "#6E7687", ...rest }: V3IconPlayProps) => <svg width="24" height="24" {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 4v16l13-8L7 4Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
